import { Controller } from "@hotwired/stimulus"
import getCookie from "~/utilities/getCookie"

export default class extends Controller {
  static targets = ["iconLight", "iconDark"]
  connect() {
    let currentTheme = getCookie("theme")

    if (!currentTheme) {
      currentTheme = "dark"
      document.cookie = `theme=${currentTheme}; path=/; max-age=31536000`
    }

    document.documentElement.dataset.theme = currentTheme
  }

  toggle() {
    let currentTheme = getCookie("theme")

    currentTheme = currentTheme === "dark" ? "light" : "dark"
    document.cookie = `theme=${currentTheme}; path=/; max-age=31536000`

    if (currentTheme === "dark") {
      this.iconDarkTarget.classList.add("hidden")
      this.iconLightTarget.classList.remove("hidden")
    } else {
      this.iconDarkTarget.classList.remove("hidden")
      this.iconLightTarget.classList.add("hidden")
    }

    document.documentElement.dataset.theme = currentTheme
  }
}
